/** TKP-181 md.71: giriş hatası uyarısının ekranda kalma süresi (ms) — genel süre 2 sn okumaya yetmiyordu. */
export const LOGIN_ERROR_TIMEOUT = 15000; // TKP-202 n.3: pasif kullanıcı uyarısı gibi uzun iletiler okunacak kadar kalır (üzerine gelince durur)

export default {
  install(Vue) {
    Vue.prototype.$handleHttpErrorByStatusCode = function(error, options = {}) {
      const status = error?.status || error?.response?.status;
      const { customMessage, timeout } = options;

      const message = customMessage || error?.response?.data?.message || error?.data?.message || error?.message || this.$t("common.failed");

      const toastOptions = {};
      if (timeout) {
        toastOptions.timeout = timeout; // TKP-181 md.71: tanımsız `time` idi → süre verilen her çağrı ReferenceError atıyordu
      }

      if (status >= 500 && status < 600) {
        this.$toast.error(message, toastOptions);
      } else if (status) {
        //statusün var ama 500 değil
        this.$toast.warning(message, toastOptions);
      } else {
        // status yoksa
        this.$toast.error(message, toastOptions);
      }
    };
  },
};
